module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-r-b-slim.f82edec3.svg";